import React, { Component } from "react";
import "./LanguageDropdown.css";

import get from 'lodash/get'

import Globe from "./Icon_Global";

class LanguageDropdown extends Component {
  state = {
    dropdownOpen: false
  };
  toggleDropdown = e => {
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };
  render() {
    const {
        languages,
        chooseLanguage,
        chosenLangCode,
        defaultLang
      } = this.props,
      sortedLangs = [defaultLang].concat(
        languages.filter(l => l.code !== defaultLang.code)
      ),
      bgStyle = {
        backgroundColor: get(
          window.settings,
          "brand.navigation.backgroundColor"
        )
      };
    const { dropdownOpen } = this.state;
    return (
      <div className={`ldd-wrapper`}>
        <div className={`ldd-header`} onClick={this.toggleDropdown}>
          <Globe />
          <span className="ldd-header-title">
            {chosenLangCode.toUpperCase()}
          </span>
          <span className="ldd-header-arrow">{dropdownOpen ? "▲" : "▼"}</span>
        </div>
        {dropdownOpen && (
          <ul className={`ldd-list`} style={bgStyle}>
            {sortedLangs.map(langObj => {
              return (
                <li
                  key={langObj.code}
                  onClick={chooseLanguage(langObj.code)}
                  className="ldd-list-item"
                >
                  {langObj.name}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }
}

export default LanguageDropdown;
